import { createStore } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { createSessionStorage } from 'src/jotai/jotiaUtil';

export const dataStore = createStore();
const selectedPrsIdStorage = createSessionStorage<string | undefined>();
export const selectedPrsIdAtom = atomWithStorage<string | undefined>('kNfge73C', undefined, selectedPrsIdStorage);
